module.exports = __webpack_public_path__ + "media/images/common/menu_regist-0d9c274d092a1a1ab9d360df263c9062.png";